<template>
  <div
    id="notification-home-modal"
    class="notification-home-modal"
  >
    <modal
      ref="notificationHomeModal"
      template="neutral"
      title=""
      ref-name="notificationHomeModal"
      :icon-enabled="false"
      :close-button-enabled="false"
      :class="{ 'notification-home-modal--hidden': isHidden }"
      class="notification-home-modal"
    >
      <button class="notification-home-modal__timer-button">
        <svg
          class="icon"
          viewBox="0 0 24 24"
          @click="closeNotificationHomeModal()"
        >
          <title>Fechar modal de notificação</title>
          <g
            fill="none"
            stroke="currentColor"
            stroke-miterlimit="10"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line
              x1="3"
              y1="3"
              x2="21"
              y2="21"
            />
            <line
              x1="21"
              y1="3"
              x2="3"
              y2="21"
            />
          </g>
        </svg>
      </button>

      <iframe
        ref="notificationIframe"
        :src="fileUrl"
        frameborder="0"
        style="width: 100%; height: 100%"
        @load="onIframeLoad"
      />
    </modal>
  </div>
</template>

<script>
export default {
  name: 'NotificationHomeModal',
  data: () => ({
    fileUrl:
      'https://storageapoiob2bprd.blob.core.windows.net/notificacao-home/NotificacaoHome.pdf',
    isHidden: true,
    pdfAlreadyChecked: false,
  }),
  methods: {
    openNotificationHomeModal() {
      const today = new Date().toISOString().split('T')[0]
      const lastOpened = localStorage.getItem('notificationHomeModalLastOpened')

      if (lastOpened === today) return

      this.pdfAlreadyChecked = false
      this.isHidden = true
      this.$refs.notificationHomeModal.open()
    },

    closeNotificationHomeModal() {
      this.$refs.notificationHomeModal.close()
    },

    onIframeLoad() {
      if (this.pdfAlreadyChecked) {
        return
      }
      this.pdfAlreadyChecked = true

      setTimeout(() => {
        const iframe = this.$refs.notificationIframe
        if (iframe && iframe.contentWindow && iframe.contentWindow.length === 0) {
          console.warn('Arquivo não disponível: Fechando modal.')
          this.closeNotificationHomeModal()
        } else {
          console.log('Arquivo disponível: Marcando como visto e exibindo modal.')
          const today = new Date().toISOString().split('T')[0]
          localStorage.setItem('notificationHomeModalLastOpened', today)
          this.isHidden = false
        }
      }, 800)
    },
  },
}
</script>

<style lang="scss">
.notification-home-modal {
  font-family: 'Exo 2', sans-serif !important;

  &__timer-button {
    width: 40px;
    height: 40px;
    position: fixed;
    top: 15px;
    right: 15px;
    z-index: 1041;
    background-color: #7f1a55;
    display: flex;
    flex-shrink: 0;
    border-radius: 50%;
    outline: none;
    transition: all ease 0.2s;
    padding: 0;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-family: 'Exo 2', sans-serif !important;
    font-weight: 300;

    svg {
      display: block;
      margin: auto;
      width: 20px;
    }
  }

  .md-dialog {
    min-width: 900px;
    width: 80%;
    height: 90%;

    .md-dialog-content > div {
      height: 100%;
    }

    .size-medium .md-dialog {
      min-height: 140px;
    }

    .standard-modal__container-dismiss {
      margin-top: 12px;
    }

    .standard-modal__title {
      font-weight: 300;
      font-size: 34px;
      line-height: 26px;
      color: #7f1a54;
      font-family: 'Exo 2', sans-serif !important;
    }
  }

  #notificationHomeModal {
    z-index: 1000;
  }

  &--hidden {
    opacity: 0;
    pointer-events: none;
  }
}
</style>
